module.exports = __webpack_public_path__ + "static/top-remit-how-af4eadcbe66771381a89ef2f48a228ae.jpg";